var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 5",
    opacity: 0.4,
    width: 35,
    height: 50,
    rx: 5,
    fill: "#28D2AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    opacity: 0.593637,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4194 4.00182L12.8458 4C11.4756 4 10.7834 4.13367 10.0631 4.51889C9.39997 4.87355 8.87355 5.39998 8.51889 6.06313C8.15936 6.7354 8.01894 7.38322 8.00182 8.58062L8.00042 13.5H0V15.5H35V13.5H28V8.84583C28 7.47564 27.8663 6.78342 27.4811 6.06313C27.1265 5.39998 26.6 4.87355 25.9369 4.51889C25.2646 4.15936 24.6168 4.01894 23.4194 4.00182ZM12.6272 6.00115L23.1542 6C24.2224 6 24.6027 6.07344 24.9937 6.28251C25.3083 6.45077 25.5492 6.69171 25.7175 7.00633L25.7602 7.09019C25.9095 7.39896 25.9778 7.73197 25.9953 8.42808L26 8.84583V13H10V8.84583C10 7.77757 10.0734 7.39726 10.2825 7.00633C10.4508 6.69171 10.6917 6.45077 11.0063 6.28251C11.3693 6.08837 11.7232 6.01118 12.6272 6.00115Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBedIcon);
export default __webpack_public_path__ + "static/media/AddBedIcon.ffd40a02.svg";
export { ForwardRef as ReactComponent };